import { z } from 'zod';
import { SubscriptionConsumableFeatures, SubscriptionConsumablePeriods } from '../../enums/Subscription';
import { BaseSchema } from '../BaseSchema';
import { SubscriptionSchema } from './Subscription';
export var SubscriptionConsumptionSchema = BaseSchema.extend({
    subscription: SubscriptionSchema,
    subscriptionId: z.string(),
    consumableFeature: z.nativeEnum(SubscriptionConsumableFeatures),
    consumablePeriodicity: z.nativeEnum(SubscriptionConsumablePeriods),
    max: z.number(),
    amount: z.number(),
    when: z.date()
});
